import { Component, inject } from '@angular/core';
import {LocaleService} from "../../../locale/locale.service";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  locale = inject(LocaleService);
}
